import { useState } from "react";
import { toast } from "sonner";
import { UploadCloud, FileCheck2, X, Loader2 } from "lucide-react";
import { api, fileSize, formatError } from "@/lib/api";

const ACCEPT = ".pdf,.ai,.cdr,.eps,.psd,.png,.jpg,.jpeg,.tif,.tiff,.svg,.zip,.rar";

export function ArtUpload({ files, onChange }) {
  const [uploading, setUploading] = useState(0);

  const handle = async (list) => {
    const chosen = Array.from(list || []);
    setUploading((n) => n + chosen.length);
    for (const file of chosen) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/orders/art-upload", fd);
        onChange((prev) => [...prev, data]);
      } catch (e) {
        toast.error(`${file.name}: ${formatError(e)}`);
      } finally {
        setUploading((n) => n - 1);
      }
    }
  };

  return (
    <div className="space-y-3" data-testid="art-upload">
      <label
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handle(e.dataTransfer.files); }}
        className="flex cursor-pointer flex-col items-center gap-2 rounded-md border-2 border-dashed border-slate-300 bg-slate-50 p-8 text-center transition-colors hover:border-[#0099DD] hover:bg-sky-50"
      >
        {uploading > 0 ? <Loader2 className="h-8 w-8 animate-spin text-[#0099DD]" /> : <UploadCloud className="h-8 w-8 text-[#0099DD]" />}
        <span className="font-semibold text-slate-900">{uploading > 0 ? "Enviando arquivo..." : "Clique ou arraste o arquivo da arte"}</span>
        <span className="text-xs text-slate-500">PDF, AI, CDR, EPS, PSD, PNG, JPG, TIFF, SVG ou ZIP · até 50 MB por arquivo</span>
        <input type="file" multiple accept={ACCEPT} className="hidden" onChange={(e) => { handle(e.target.files); e.target.value = ""; }} data-testid="input-art-file" />
      </label>
      {files.map((f) => (
        <div key={f.id} className="flex items-center gap-3 rounded-md border border-green-200 bg-green-50 px-4 py-2.5" data-testid={`art-file-${f.id}`}>
          <FileCheck2 className="h-4 w-4 text-green-700" />
          <span className="flex-1 truncate text-sm font-semibold">{f.name}</span>
          <span className="text-xs text-slate-500">{fileSize(f.size)}</span>
          <button type="button" onClick={() => onChange((prev) => prev.filter((x) => x.id !== f.id))} aria-label="Remover arquivo" data-testid={`art-remove-${f.id}`}>
            <X className="h-4 w-4 text-slate-400 hover:text-red-500" />
          </button>
        </div>
      ))}
    </div>
  );
}
